import React from 'react'

const Error = () => {
  return (
    <>
      <main className='home-content'>
        <h1>An error occurred!</h1>
        <div>Could not find this page.</div>
      </main>
    </>
  )
}

export default Error